// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const revavroom: PokeData = {
  "id": 966,
  "name": "revavroom",
  "height": 18,
  "weight": 1200,
  "base_experience": 175,
  "types": [
    PokeType.STEEL,
    PokeType.POISON
  ],
  "api_moves": [
    "headbutt",
    "screech",
    "lick",
    "smog",
    "sludge",
    "poison-gas",
    "swagger",
    "uproar",
    "taunt",
    "gyro-ball",
    "assurance",
    "magnet-rise",
    "poison-jab",
    "gunk-shot",
    "iron-head",
    "shift-gear",
    "spin-out"
  ],
  "moves": [
    "headbutt",
    "lick",
    "poison-gas",
    "poison-jab",
    "sludge-bomb",
    "mortal-gas",
    "gear-up",
    "iron-defense",
    "acid",
    "metal-rush",
    "poison-fang",
    "scrap-throw",
    "venom-drench"
  ],
  "evolution_chain": {
    "id": 505,
    "item": null,
    "species": [
      {
        "name": "varoom",
        "order": 942,
        "types": [
          PokeType.STEEL,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "revavroom",
        "order": 943,
        "types": [
          PokeType.STEEL,
          PokeType.POISON
        ],
        "evolves_from_species_id": 965,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 125,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
